/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Form_Gps_ProviderInputs */

const vi_vehicle_form_gps_provider = /** @type {(inputs: Vehicle_Form_Gps_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà cung cấp GPS`)
};

/**

* @param {Vehicle_Form_Gps_ProviderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_form_gps_provider = /** @type {((inputs?: Vehicle_Form_Gps_ProviderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Form_Gps_ProviderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_form_gps_provider(inputs)
});